export const reportCashReconciliationTypes = {
  GET_REPORT_CASH_RECONCILIATION: 'GET_REPORT_CASH_RECONCILIATION',
  SET_REPORT_CASH_RECONCILIATION_FILTERS: 'SET_REPORT_CASH_RECONCILIATION_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};
